/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';

import styles from './paper.module.css';

const PaperSeparator = ({ margin, ...props }) => (
  <span className={styles.separator} style={{ margin: -margin }} {...props} />
);

PaperSeparator.defaultProps = {
  margin: 10,
};

PaperSeparator.propTypes = {
  margin: PropTypes.number,
};

export default PaperSeparator;
